module.exports = require("node-gettext");